/**
 * Format integers with en-US thousands separators (e.g. 11518 → "11,518").
 * Non-finite numbers and non-numeric values are returned unchanged.
 */
export function formatNumber(value) {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value.toLocaleString("en-US");
  }
  if (typeof value === "string" && value.trim() !== "") {
    const n = Number(value);
    if (Number.isFinite(n)) {
      return n.toLocaleString("en-US");
    }
  }
  return value;
}
